import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

// There is a chance for the app to fail here. This method assumes that
// the <hhtml /> lang property is set and follows the XX-XX format.
const parseDocumentLocale = () => {
  const hyphenatedLocale = document.documentElement.lang;
  const region = hyphenatedLocale.split("-")[1].toUpperCase();
  const parsedLocale = hyphenatedLocale.split("-")[0] + region;

  return parsedLocale;
};

export const LanguageSelector = () => {
  const defaultLocale = parseDocumentLocale();
  const { t, i18n } = useTranslation();
  const [locale, setLocale] = useState(defaultLocale);

  const getAvailableRegionLocales = () => {
    const locales = [
      "enUS",
      "zhTW",
      "koKR",
      "jaJP",
      "deDE",
      "deCH",
      "deAT",
      "frCH",
    ];

    const region = locale.slice(-2);
    const availableLocales = locales.filter((locale) =>
      locale.includes(region),
    );

    return availableLocales;
  };

  const handleChange = (event: SelectChangeEvent) => {
    setLocale(event.target.value);
    i18n.changeLanguage(event.target.value);
  };

  return (
    <>
      {getAvailableRegionLocales().length > 1 && (
        <FormControl sx={{ paddingTop: "20px;", width: 125 }}>
          <InputLabel id="demo-simple-select-label">{t("Language")}</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={locale}
            label={t("Language")}
            onChange={handleChange}
          >
            {getAvailableRegionLocales().map((locale, index) => (
              <MenuItem key={index} value={locale}>
                {locale}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </>
  );
};
